// 英文

import enLocale from 'element-ui/lib/locale/lang/en'
import Navigation from './Navigation/Navigation_en' // 首页
import login from './login/login_en' // 登录注册
import chat from './chat/chat_en' // im
import appBackstage from './app_backstage/app_backstage_en' // 后台文件（除 自定义应用模块）
import approval from './approval/approval_en' // 前台审批
import attendance from './attendance/attendance_en' // 考勤
import customBackstage from './custom_backstage/custom_backstage_en' // 自定义后台
import customReception from './custom_reception/custom_reception_en' // 自定义前台
import dataAnalysis from './data_analysis/data_analysis_en' // 数据分析
import email from './email/email_en' // 邮件
import knowledge from './knowledge/knowledge_en' // 知识库
import library from './library/library_en' // 文件库
import memo from './memo/memo_en' // 备忘录
import projectTask from './project_task/project_task_en' // 项目任务
import baseCommon from './base_common/base_common_en' // 基础通用的（包括用户、公司、登录等信息）
import workbench from './workbench/workbench_en' // 工作台
import globalSettings from './global_settings/global_settings_en' // 工作台
import utils from './utils/utils_en' // 工具类 如：constant、tool等
import salary from './salary/salary_en' // 工具类 如：constant、tool等
import okr from './okr/okr_en' // okr
import businessFlow from './business_flow/businessFlow_en' // 业务流程
import personnelMatrix from './personnelMatrix/PersonnelMatrix_en' // 人员矩阵
export default {
  ...enLocale,
  ...appBackstage,
  ...Navigation,
  ...login,
  ...chat,
  ...approval,
  ...attendance,
  ...customBackstage,
  ...customReception,
  ...dataAnalysis,
  ...email,
  ...knowledge,
  ...library,
  ...memo,
  ...projectTask,
  ...baseCommon,
  ...workbench,
  ...globalSettings,
  ...utils,
  ...salary,
  ...okr,
  ...businessFlow,
  ...personnelMatrix
}
